import React from 'react'
import PropTypes from 'prop-types'
import ListItem from 'components/AdListItem/ListItem'
import { numberGroup } from 'utils/format'

const containsSpaces = (inputString) => inputString.includes(' ')

export const formatPrice = (priceString) => {
  if (!priceString) return ''
  if (!containsSpaces(priceString)) priceString = numberGroup(priceString)
  const firstCharIsNumber = /^\d+$/.test(priceString.charAt(0))
  const lastCharIsNumber = /^\d+$/.test(priceString.charAt(priceString.length - 1))
  if (!firstCharIsNumber || !lastCharIsNumber) return priceString
  return `${priceString} kr`
}

const BostadAd = ({
  clickUrl,
  imageUrl,
  subject,
  productLabel,
  location,
  price,
  size,
  rooms,
  storeLogoUrl,
}) => {
  const formattedPrice = formatPrice(price)
  const formattedAd = {
    adStatus: 'active',
    advertiser: { type: 'company' },
    category: [{ name: 'Bostad' }],
    location: [{ name: location }],
    price: formattedPrice,
    subject,
    toplistingLabel: productLabel,
    isToplisting: true,
  }

  if (storeLogoUrl) {
    formattedAd.store = {
      logo: {
        url: storeLogoUrl,
      },
    }
  }

  return <ListItem ad={formattedAd} url={clickUrl} imageSrc={imageUrl} adParams={[rooms, size]} />
}

BostadAd.propTypes = {
  clickUrl: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  productLabel: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  price: PropTypes.string,
  size: PropTypes.string,
  rooms: PropTypes.string,
  storeLogoUrl: PropTypes.string,
}

export default BostadAd
